import React, { Component } from "react";
import "./StoriesContainer.css";

import { injectIntl, defineMessages } from "react-intl";
import { Grid, Image, Message, Loader, Icon } from "semantic-ui-react";

import client from "../../../clientService";

import _ from "lodash"

import StoriesMenu from "../StoriesMenu/StoriesMenu";
import StoriesList from "../StoriesList/StoriesList";
import DeepSingPlayer from "../../DeepSingPlayer/DeepSingPlayer";
import PlayerContext from "../../../playerContext";
import Moto from "../Moto/Moto";
import Draggable from "react-draggable";
import YouTubePlayer from "../../YouTubePlayer/YouTubePlayer";

import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

import loading from "./images/deepsing_loading.svg"
import StoriesPreview from "../StoriesPreview/StoriesPreview";
import ChangingProgressProvider from "./ChangingProgressProvider";
class StoriesContainer extends Component {
    static contextType = PlayerContext

    state = {
        storyStatus: "",
        duration: 180,
        processingOptions: {
            "translator": "neural",
            "stylize": true,
            "dynamic": true,
            "normalizeSentiment": false,
            "neuralModel": "-1",
            "styleFactor": "0.1"
        }
    }

    // shouldComponentUpdate(nextProps, nextState) {
    //     console.log("story copntainer changed")
    //     console.log(nextProps, nextState);
    //     console.log(this.props, this.state);
    //     return false
    // }

    componentDidMount(prevProps, prevState) {
        const playerStatus = this.context

        const storyStatusUpdater = setInterval(() => {
            // client.service("story").find({
            //     query: {
            //         "_id": playerStatus.storyId,
            //         $sort: {
            //             createdAt: -1
            //         }
            //     }
            // })
            client.service("story").get(playerStatus.storyId)
                .then(resp => {
                    console.log(resp);
                    
                    resp && this.setState({ "storyStatus": resp.status });

                    resp.videoDuration && this.setState({ "duration": resp.videoDuration });
                    resp.processingOptions && this.setState({ "processingOptions": resp.processingOptions });

                    resp.status === "completed" && clearInterval(storyStatusUpdater)
                })
                .catch(e => {
                    this.setState({ "storyStatus": "notfound" });
                })
        }, 2000)

    }

    render() {
        const { intl: { formatMessage } } = this.props;

        const getProcessingTime = story => {
            const duration = story.duration;
            let processingTime = duration;
            const options = story.processingOptions;

            const dynamic = options.dynamic
            const stylize = options.stylize

            //Για το απλό είναι ~0.17x
            // (χωρις το dynamic)

            // static + no stylization: 0.1x
            // static + stylization: 0.2x

            // dynamic + no stylization: 0.7x
            // dynamic + stylization: 1.3x

            // sample options
            // const processingOptions = {
            //     "translator": "neural",
            //     "stylize": true, 
            //     "dynamic": false, 
            //     "normalizeSentiment": false, 
            //     "neuralModel": " - 1", 
            //     "styleFactor": "0.1"
            // }


            if (dynamic) {
                processingTime = stylize ? 2.5 * duration : 1.1 * duration
            } else {
                processingTime = 0.3 * duration
            }

            return processingTime
        }


        let totalProcessingTime = getProcessingTime(this.state);

        return (
            <Grid.Column width={16} style={{ "height": "100%" }}>
                <Grid stackable columns='equal' style={{ "marginBottom": 0 }}>
                    {/* <Grid.Column stretched width="6">
                        <StoriesMenu style={{ "background": "black", "color": "white" }} />
                    </Grid.Column> */}
                    <Grid.Column stretched width="16" style={{ "overflowY": "hidden", "overflowX": "hidden", "height": "100vh", "padding": "0px" }}>


                        {this.state.storyStatus === "notfound" &&
                            <div style={{ "display": "flex", "justifyContent": "center" }}>
                                <div style={{ "display": "flex", "flexDirection": "column", "justifyContent": "center" }}>
                                    <Message icon className="inverted" style={{ "background": "black", "textAlign": "center" }}>
                                        <Icon name='microphone slash' />
                                        <Message.Content>
                                            <Message.Header>Story lost in timespace.</Message.Header>
                                            Story not found. Please submit your song at <a href="https://deepsing.com">deepsing.com</a>
                                        </Message.Content>
                                    </Message>
                                </div>
                            </div>
                        }

                        {this.state.storyStatus === "error" &&
                            <div style={{ "display": "flex", "justifyContent": "center" }}>
                                <div style={{ "display": "flex", "flexDirection": "column", "justifyContent": "center" }}>
                                    <Message icon className="inverted" style={{ "background": "black", "textAlign": "center" }}>
                                        <Icon name='microphone slash' />
                                        <Message.Content>
                                            <Message.Header>Story lost in timespace.</Message.Header>
                                            This story is broken. Please submit again your song at <a href="https://deepsing.com">deepsing.com</a> or contact us.
                                        </Message.Content>
                                    </Message>
                                </div>
                            </div>
                        }

                        {this.state.storyStatus === "pending" &&
                            <div style={{ "display": "flex", "justifyContent": "center" }}>
                                <div style={{ "display": "flex", "flexDirection": "column", "justifyContent": "center" }}>
                                    <Message icon className="inverted" style={{ "background": "black", "textAlign": "center" }}>
                                        <Icon name='circle notched' loading />
                                        <Message.Content>
                                            <Message.Header>Your story is waiting patiently in the processing queue.</Message.Header>
                                            All queues are full, pending processing.
                                            </Message.Content>
                                    </Message>
                                </div>
                            </div>
                        }

                        {this.state.storyStatus === "inprogress" &&
                            <div style={{ "display": "flex", "justifyContent": "center" }}>
                                <div style={{ "display": "flex", "flexDirection": "column", "justifyContent": "center" }}>
                                    <Message icon className="inverted" style={{ "background": "black", "textAlign": "center" }}>
                                        {/* <Icon name='circle notched' loading /> */}
                                        <ChangingProgressProvider
                                            minValue={0}
                                            maxValue={totalProcessingTime}
                                            values={_.range(totalProcessingTime)}>
                                            {percentage => (
                                                <CircularProgressbar
                                                    value={parseInt((100 * percentage) / totalProcessingTime)}
                                                    text={`${parseInt((100 * percentage) / totalProcessingTime)}%`}
                                                    styles={buildStyles({
                                                        pathTransition:
                                                          percentage === 0 ? "none" : "stroke-dashoffset 0.5s ease 0s"
                                                      })}
                                                />
                                            )}
                                        </ChangingProgressProvider>
                                        <Message.Content>
                                            <Message.Header>We are now trying to see and draw your visual story.</Message.Header>
                                            The song is being processed. Please wait. Processing time should be about {parseInt(totalProcessingTime)} seconds.
                                                    </Message.Content>
                                    </Message>
                                    <Image
                                        src={loading}
                                        fluid
                                        centered
                                    />
                                </div>
                            </div>
                        }


                        {this.state.storyStatus === "completed" && <StoriesMenu />}
                        {this.state.storyStatus === "completed" && <YouTubePlayer />}
                        {this.state.storyStatus === "completed" && <DeepSingPlayer />}

                    </Grid.Column>
                </Grid>
                {/* {this.state.storyStatus === "completed" && <StoriesPreview />} */}

            </Grid.Column >
        );
    }
}

export default injectIntl(StoriesContainer);